export default __webpack_public_path__ + "static/media/sun-energy-bg.a826779b.jpeg";